import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ThaiDatePipe } from "../thai-date.pipe";
import { TranslatePipe } from "../translate.pipe";
import { DateDifferencePipe } from "../date-difference.pipe";
import { FileSizePipe } from "../filesize.pipe";

@NgModule({
  declarations: [ThaiDatePipe, TranslatePipe, DateDifferencePipe, FileSizePipe],
  imports: [CommonModule],
  exports: [ThaiDatePipe, TranslatePipe, DateDifferencePipe, FileSizePipe],
})
export class PipeModule {
  constructor() {}
}
